import { StyleSheet } from 'react-native';

import maxContainerWidthStyle from '../../../styles/max-container-width/max-container-width.style';
import { mediaQueryValues } from '../../media-query';
import {
  centeredBox,
  extraSmallMarginBottomBox,
  extraSmallPaddingVerticalBox,
  mediumPaddingHorizontalBox,
  smallPaddingVerticalBox,
} from '../../view-style';

const mediaQuery = mediaQueryValues();

export default StyleSheet.create({
  container: {
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 'auto',
  },
  content: {
    ...maxContainerWidthStyle,
  },
  image: {
    height: mediaQuery.smallImage,
  },
  view: {
    display: 'flex',
    ...centeredBox,
    ...mediumPaddingHorizontalBox,
    ...smallPaddingVerticalBox,
  },
  text: {
    ...extraSmallMarginBottomBox,
  },
  buttonContent: {
    ...mediumPaddingHorizontalBox,
    ...extraSmallPaddingVerticalBox,
  },
  buttonContainer: {
    marginHorizontal: 'auto',
    width: '100%',
    maxWidth: 400,
  },
  inputContainer: {
    marginHorizontal: 'auto',
    width: '100%',
    maxWidth: 400,
  },
  optionContainer: {
    marginHorizontal: 'auto',
    width: '100%',
    maxWidth: 460,
  },
});
